import React, { useEffect, useState, useContext } from 'react';
import { Button, Form, Popconfirm, Table, Select, Layout, Tag, InputNumber, Modal } from "antd";
import { getGridTableHeight } from '../Common/util';
import { excelDownload, EditableCell, EditableRow } from '../Common/function';
import axios from '../Common/axios';
import Papa from "papaparse";
import { postSaveTemplateUpload } from '../Common/api';
import AppContext from '../../components/AppContext';

const { Content } = Layout;
const { Option } = Select;

/** -------------------------------------------------------------------------- **/
const InfoTable = ({ data, columnData, reportId, reportInfo, infoType, isLoading, onClickSaveHandler, onReloadHandler,assetTypeOrg }) => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    // 변수 선언
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState(data || []);
    const [deleteData, setDeleteData] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    // State to store parsed data
    const [parsedData, setParsedData] = useState([]);
    //State to store table Column name
    const [tableRows, setTableRows] = useState([]);
    //State to store the values
    const [values, setValues] = useState([]);
    const [changeData, setChangeData] = useState([]);
    const [uniqueId, setUniqueId] = useState(1);
    const confirmed = reportInfo?.confirm === 'Y' ? true : false;
    // 예외사항은 항상 수정 가능하도록 설정
    const created_ymd = true;
    // let changeData = [];

    let excel_title = '';
    let titleName="예외사항";
    // 미확정상태의 경우 operation칼럼 추가 및 edit기능 추가
    let mergedColumns = [];
    /** -------------------------------------------------------------------------- **/

    const operationColumns = [
        {
            key: 'operation',
            width: '0px',
            defualt: '',
        },
        {
            title: 'delete',
            width: '100px',
            align: 'center',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.id, record.unique_id? record.unique_id : 0)}>
                        {/* <a>Delete</a> */}
                        <a>Delete</a>
                    </Popconfirm>
                ) : null,
        },
    ];

    // 취약점 진단 하면 최초 진단날짜를 확인해 자산 수정 못하게 막음 
    if (!confirmed && created_ymd) {
       
        const columns = [...columnData];
        
        operationColumns.map((col) => {
            columns.push(col);
        });

        mergedColumns = columns.map((col) => {

            if (!col.editable) { return col; }
            let i=0;
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    tabIndex: 0,
                    handleSave,
                }),
            };
        });
    } else {
        mergedColumns = [...columnData];
    }

    // 자동으로 코드 값을 만들어 적용하는 분분
    // let test = dataSource.filter(d => d["asset_type"] === assetType);
    // let len = dataSource.length;
    // let maxValue = "";
    // let assetType = ""; 
    // let cdName = infoType+"_cd";
    // let cdType = infoType+"_type";

    // for(let i=0 ; len > i; i++){
    //   maxValue = dataSource[i][cdName] > maxValue ? dataSource[i][cdName] : maxValue;
    //   assetType = dataSource[i][cdType];
    // }

    // let maxValueNum = Number(maxValue.substring(idNumberCount))+1; 
    // let zeroVal = maxValueNum > 99 ? "" : maxValueNum > 9 ? "0" : "00"; 
    // let maxValueStr = assetType+zeroVal+maxValueNum;
    // let copyVal = dataSource[0];

    // 행 추가
    const handleAdd = () => {

        const newData = {
                operation: 'C',
                id: 0,
                unique_id: uniqueId,
                report_id: reportId,
                asset_cd: "",
                measure_cd: "",
                current_status : "",
                result_cd: "Y",
                corrective_desc: "",
                user_company: myContext.companyCode,
            };        

        setUniqueId(uniqueId + 1);
        setDataSource([...dataSource, newData]);
    };

    // 행 삭제
    const handleDelete = (keyId, keyUniqueId) => {
        // if(dataSource.length < 2){
        //     Modal.info({ title:titleName, content:"최소 한개 자산은 있어야 합니다.", okText: "Close" });
        //     return;
        // }
        if (keyId === 0) {
            setDataSource(prevItems => prevItems.filter(item => item.unique_id !== keyUniqueId));
        }else{
            setDataSource(prevItems => prevItems.filter(item =>  item.id !== keyId));

            const delData = dataSource.filter((item) => item.id === keyId);
            if (delData && delData.length > 0) {
                const deletedItem = {...delData[0], operation: 'D'};
                setDeleteData(prev => [...prev, deletedItem]);
            }
        }
    };

    const hasDuplicatePairs = (paramData)=> {
        const seen = new Set();
        
        for (const obj of paramData) {
            // null이나 빈 값은 중복 체크에서 제외
            if (!obj.asset_cd || !obj.measure_cd) {
                continue;
            }
            const key = `${obj.asset_cd}-${obj.measure_cd}`;
            if (seen.has(key)) {
                return true; // 중복 발견
            }
            seen.add(key);
        }
        return false;
    }
    //행 저장
    const handleSave = (row) => {

        //비교를 위하여 깊은 복사 실행
        const newData = JSON.parse(JSON.stringify(dataSource));
        let index=0;

        if(row.id>0){
            index = newData.findIndex((item) => row.id === item.id);
        }else{
            index = newData.findIndex((item) => row.unique_id === item.unique_id);
            if( index == -1 ){
                Modal.info({ title:titleName, content:"새로 생성된 값 중에서 다른 값은 수정 가능하나 \n'코드' 값은 바로 수정이 되지 않습니다. \n한번 저장(save)하시고 수정해 주시기 바랍니다.", okText: "Close" });
                return;
            }
        }

        const item = newData[index];
        const tempData = [...newData];
        tempData.splice(index, 1, { ...newData[index], ...row });
        
        if(hasDuplicatePairs(tempData)) {
            Modal.error({title:titleName, content:titleName+"에 중복된 자산/진단 코드값이 있습니다. 확인 후 다시 시도하세요.", okText:"Close"});
            return;
        }

        if (JSON.stringify(item) != JSON.stringify(row)) {
            row.operation = row.id == '0' ? 'C' : 'U';
            newData.splice(index, 1, {
                ...item,
                ...row,
            });

            setDataSource(newData);
        }
    };

    // 파일업로드
    const onChangeUploadHandler = (event) => {

        setShowUpload(true);
        setIsDataChange(false);
        // Passing file data (event.target.files[0]) to parse using Papa.parse
        Papa.parse(event.target.files[0], {
            header: true,
            skipEmptyLines: 'greedy',
            complete: function (results) {
                const rowsArray = [];
                const valuesArray = [];

                // Iterating data to get column name and their values
                results.data.map((d) => {
                    rowsArray.push(Object.keys(d));
                    valuesArray.push(Object.values(d));
                });

                // Parsed Data Response in array format
                setParsedData(results.data);

                // Filtered Column Names
                setTableRows(rowsArray[0]);

                // Filtered Values
                setValues(valuesArray);
            },
        });
    };

    // 파일업로드 저장
    const onClickFileSaveHandler = () => {

        setUploading(true);
        setIsDataChange(false);
        axios.post(postSaveTemplateUpload(), {
            reportId: reportId,
            infoType: infoType,
            parsedData: parsedData,
        }, { logType: '/create/VaBaseUpload/', logCompany: reportInfo.com_cd, logParam: reportId })
            .then((response) => {
                //console.log(response);
                setUploading(false);
                //Modal.info({title: "OK.", okText:"Close"});
                if (response.data == '000') {
                    Modal.info({title:titleName, content:"업로드가 정상적으로 적용되었습다.", okText: "Close", onOk() {
                            // 분석기준 재조회
                            onReloadHandler();
                            setShowUpload(false);
                        }
                    });
                } else {
                    Modal.info({ title:titleName, content:response.data, okText: "Close" });
                }
            })
            .catch((error) => {
                setUploading(false);
                Modal.error({ title:titleName, content:error.message, okText: "Close" });
            });
    };

    useEffect(() => {
        //저장,수정 대상 추가
        if (dataSource && Array.isArray(dataSource)) {
            const changeData = dataSource.filter((item) => item.operation && item.operation != '');
            setChangeData(changeData);
        }
    }, [dataSource]);

    useEffect(() => {
        setDataSource(data || []);
        setDeleteData([]);
        setChangeData([]);
    }, [data]);

    // 정보 변경시 재조회
    useEffect(() => {
        if (isDataChange) {
            setDataSource();
        }
    }, [isDataChange]);

    /** -------------------------------------------------------------------------- **/
    // const saveData = () => {
    //     const result = onClickSaveHandler(changeData.concat(deleteData));
    //     if(result){
    //         setDeleteData([]);
    //         setChangeData([]);
    //     }
    // }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <table style={{ width: '100%' }}><tbody>
                <tr>
                    <td><div style={{ marginLeft: '20px' }}>총 {dataSource?.length} 개</div></td>
                    <td style={{ textAlign: 'right' }}>
                        {confirmed ? (
                            <><span style={{ color: '#ff0000' }}>확정된 보고서로 자산정보 수정이 불가합니다.</span></>
                        ) : (
                            <><span style={{ color: '#0378c7', paddingRight: '20px' }}>※ 진단항목에 현황 값이 있으면 취약점 진단 결과는 이 값으로 대체 됩니다.</span>

                                { (!confirmed && created_ymd)  ? (
                                    <>
                                        <Button type="default" onClick={() => handleAdd()}>
                                            Add a row
                                        </Button>
                                        <Button type="primary" onClick={()=>onClickSaveHandler(changeData.concat(deleteData))}>
                                        {/* <Button type="primary" onClick={() => saveData()}> */}
                                            Save
                                        </Button>
                                    </>
                                ) : (
                                    <span style={{ display: 'none' }}>버튼 조건 불충족: confirmed={String(confirmed)}, created_ymd={String(created_ymd)}</span>
                                )}
                            </>
                        )}
                        <Button type="default" onClick={() => excelDownload(excel_title, dataSource, ['report_id'])}>
                            Excel Download
                        </Button>
                    </td>
                </tr></tbody>
            </table>
            {showUpload ? (
                <div className="section" id="uploadTable">
                    <Content style={{ height: 450, backgroundColor: '#fff', overflow: 'scroll' }}>
                        <table>
                            <thead>
                                <tr>
                                    {tableRows.map((rows, index) => {
                                        return <th key={index}>{rows}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {values.map((value, index) => {
                                    return (
                                        <tr key={index}>
                                            {value.map((val, i) => {
                                                return <td key={i}>{val}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Content>
                </div>
            ) : (
                <Form form={form} component={false}>
                    <Table
                        columns={mergedColumns}
                        dataSource={dataSource}
                        scroll={{ y: getGridTableHeight(450) }}
                        loading={{
                            size: "large",
                            spinning: isLoading
                          }}
                        rowKey={(record) => (record.id && record.id !== 0 ? record.id : `new-${record.unique_id}`)}
                        pagination={false}
                        bordered size={"small"}
                        style={{ height: getGridTableHeight(420) }}
                        showSorterTooltip={false}
                        components={{
                            body: {
                                row: EditableRow,
                                cell: EditableCell,
                            },
                        }}
                        rowClassName={() => 'editable-row'}
                        // onRow={(record) => {
                        //     return {
                        //       style: {
                        //         background: record.status === 'c' ? '#e6f7ff' : 
                        //         record.status === 'u' ? '#cceeaa':'#fff1f0',
                        //       },
                        //     };
                        //   }}
                    />
                </Form>
            )}
        </>

    );
}
export default InfoTable;